export default (items, savedJobs) => {
  if (savedJobs && Array.isArray(savedJobs) && savedJobs.length > 0) {
    const cache = savedJobs.reduce((p, c) => (p[c] = c) && p, {});
    return items.map(job => ({ ...job, isSaved: !!cache[job.jobId] }));
  }
  return items;
};
